import Header from './Header.js'
import ImageTextComponent from './ImageTextComponent.js';
import Image1 from "../assets/img/pizza-image1.jpg";
import Image2 from "../assets/img/pizza-image2.jpg";
import { DESC_FOTO1, DESC_FOTO2 } from '../utilities/Constants.js';
import ReviewsComponent from './Reviews.js';
import MapLocation from './MapLocation.js';

const Home = () => {
  return (
    <>
      <Header />
      <div className="container-fluid text-center">
        <div className="row justify-content-center d-flex mx-auto">
          <div className="col-md-9">
            <ImageTextComponent
              image={Image1}
              title="La nostra Pizza"
              description={DESC_FOTO1}
              reverse={true}
            />
          </div>

          <div className="col-md-9">
            <ImageTextComponent
              image={Image2}
              title="Il nostro Impasto"
              description={DESC_FOTO2}
              reverse={false}
            />
          </div>
        </div>
      </div>
      <div className="row justify-content-center d-flex mx-auto colore-terziario mt-3">
        <ReviewsComponent />
      </div>
      <div className="container-fluid text-center mt-3 mb-2">
        <div className="row justify-content-center d-flex mx-auto imageTextContainer rounded">
          <div className="col-md-9">
            <h4 className="bold-text">Vieni a trovarci</h4>
            <MapLocation />
          </div>
        </div>
      </div>
    </>
  )
}

export default Home;